import api from "./api";

const bannerService = {
  // Get all banners
  getAllBanners: async (params = {}) => {
    try {
      const response = await api.get("/api/banners", { params });
      return response.data;
    } catch (error) {
      console.error("Get all banners error:", error);
      throw error;
    }
  },

  // Get banner by ID
  getBannerById: async (id) => {
    try {
      const response = await api.get(`/api/banners/${id}`);
      return response.data;
    } catch (error) {
      console.error("Get banner by ID error:", error);
      throw error;
    }
  },

  // Create banner
  createBanner: async (formData) => {
    try {
      const response = await api.post("/api/banners", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Create banner error:", error);
      throw error;
    }
  },

  // Update banner
  updateBanner: async (id, formData) => {
    try {
      const response = await api.put(`/api/banners/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Update banner error:", error);
      throw error;
    }
  },

  // Delete banner
  deleteBanner: async (id) => {
    try {
      const response = await api.delete(`/api/banners/${id}`);
      return response.data;
    } catch (error) {
      console.error("Delete banner error:", error);
      throw error;
    }
  },
};

export default bannerService;
